import React from "react";
import { getLocationDetails, CATEGORY_CHILD_LOCATIONS } from '@lds/store-locator-js-sdk';
import { useStoreCategories } from "./useStoreCategories";
export const useBullseyeLocationDetails = ({ options, disable, stateCategories, stateActiveStore }) => {
    const [location, setLocation] = React.useState();
    const [locationDetailsError, setLocationDetailsError] = React.useState();
    const [isLoading, setIsLoading] = React.useState(false);
    const catOptions = {
        lang: !options?.lang ? 'en-CA' : options.lang,
        clientId: options?.clientId,
        apiKey: options?.apiKey,
    };
    const catres = useStoreCategories(catOptions);
    // eslint-disable-next-line complexity
    const getOneLocationDetails = React.useCallback(async (overrideOptions) => {
        // don't attempt to load data if no request for store details, virtual store
        const searchOptions = {
            ...options,
            ...overrideOptions,
        };
        if (!searchOptions.lclId) {
            setLocation(undefined);
            setLocationDetailsError(undefined);
            setIsLoading(false);
            return;
        }
        if (location) {
            return;
        }
        if (stateActiveStore?.commonInfo?.lclId === searchOptions.lclId) {
            // Don't fetch details again
            setLocation(stateActiveStore);
            return;
        }
        setIsLoading(true);
        try {
            if (!catres.categories && stateCategories?.length === 0) {
                setLocation(undefined);
                setLocationDetailsError(undefined);
                setIsLoading(false);
                let fetchedCategories;
                if (stateCategories.length === 0) {
                    fetchedCategories = await catres.getAllCategories();
                }
                if (disable) {
                    const { location: newLocation, error: err, } = await getLocationDetails(searchOptions, fetchedCategories);
                    const { location: tmsLocation, error: tmsLocationError, } = await getLocationDetails({
                        ...searchOptions,
                        lclId: (newLocation?.childLocationIds[CATEGORY_CHILD_LOCATIONS.TMS_DEPT])
                            || newLocation?.commonInfo.lclId,
                    }, fetchedCategories);
                    setLocation({
                        ...newLocation,
                        commonInfo: {
                            ...newLocation.commonInfo,
                            // eslint-disable-next-line max-len
                            businessHours: tmsLocation?.commonInfo?.businessHours ?? newLocation.commonInfo.businessHours,
                        },
                    });
                    setLocationDetailsError(err || tmsLocationError);
                    setIsLoading(false);
                }
                return;
            }
            if (!searchOptions || !searchOptions.clientId || !searchOptions.lclId) {
                setLocation(undefined);
                setLocationDetailsError(undefined);
                setIsLoading(false);
            }
            else if (!isLoading) {
                if (options.hoursOnly) {
                    const { location: tmsLocation, error: tmsLocationError, } = await getLocationDetails(searchOptions, catres.categories || stateCategories);
                    setLocationDetailsError(tmsLocationError);
                    setIsLoading(false);
                    setLocation(tmsLocation);
                }
                else {
                    const { location: newLocation, error: err, } = await getLocationDetails(searchOptions, catres.categories || stateCategories);
                    const { location: tmsLocation, error: tmsLocationError, } = await getLocationDetails({
                        ...searchOptions,
                        lclId: (newLocation?.childLocationIds[CATEGORY_CHILD_LOCATIONS.TMS_DEPT])
                            || newLocation?.commonInfo.lclId,
                    }, catres.categories || stateCategories);
                    setLocation({
                        ...newLocation,
                        commonInfo: {
                            ...newLocation.commonInfo,
                            // eslint-disable-next-line max-len
                            businessHours: tmsLocation?.commonInfo?.businessHours ?? newLocation.commonInfo.businessHours,
                        },
                    });
                    setLocationDetailsError(err || tmsLocationError);
                    setIsLoading(false);
                }
            }
        }
        catch (errx) {
            setLocationDetailsError(errx);
            setIsLoading(false);
            setLocation(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps, max-len
    }, [stateCategories?.length, catres.getAllCategories, JSON.stringify(options), isLoading, catres.categories]);
    React.useEffect(() => {
        if (!disable) {
            getOneLocationDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(options), catres.categories, disable]);
    const error = catres.error || locationDetailsError;
    return { location, error, isLoading, getOneLocationDetails };
};
//# sourceMappingURL=useBullseyeLocationDetails.js.map